import React from 'react'
import PropTypes from 'prop-types'
import RowButton from 'components/atoms/row-button'
import SelectTableFilter from 'components/atoms/select-table-filter'
import SellerBadge from 'domains/seller/atoms/seller-badge'
import GenderBadge from 'domains/seller/atoms/gender-badge'
import { SELLER_TYPE, GENDER, BANNED_REASON, IS_BANNED_LABEL } from 'domains/seller/constants'
import StringUtil from 'utils/string-util'

const propTypes = {
  buttonText       : PropTypes.string,
  buttonColour     : PropTypes.string,
  isButtonDisabled : PropTypes.func,
  onButtonClick    : PropTypes.func
}

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

const filterPropTypes = {
  column: PropTypes.object
}

/**
 * Columns definition for Seller Table
 * @param {string} buttonText - The text that appears at the button on each row
 * @param {string} buttonColour - Bootstrap button type class name (eg. primary)
 * @param {Function} isButtonDisabled - function that will check whether the button on particular row is disabled
 * @param {Function} onButtonClick - function that will run when the button is clicked
 */

const sellerTableColumns = ({
  buttonText,
  buttonColour,
  isButtonDisabled,
  onButtonClick
}) => {
  const GenderFilter = ({ column }) => {
    const options = Object.keys(GENDER).map((key) => (
      {
        label : GENDER[key],
        value : GENDER[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  const SellerTypeFilter = ({ column }) => {
    const options = Object.keys(SELLER_TYPE).map((key) => (
      {
        label : SELLER_TYPE[key],
        value : SELLER_TYPE[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  const GenderCell     = (row) => <GenderBadge gender= { row.cell.value } />
  const SellerTypeCell = (row) => <SellerBadge seller_type= { row.cell.value } />

  const ActionCell = ({ cell: { row } }) => {

    const disabled = isButtonDisabled ? isButtonDisabled(row.original) : false

    return (
      <RowButton
        data={ row.original }
        color={ buttonColour }
        onClick={ onButtonClick }
        disabled={ disabled }
        text={ buttonText }
      />
    )
  }

  // eslint-disable-next-line react/prop-types
  const IsBannedFilter = ({ column }) => {
    const options = Object.keys(IS_BANNED_LABEL).map((key) => (
      {
        label : IS_BANNED_LABEL[key].label,
        value : IS_BANNED_LABEL[key].value
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  // eslint-disable-next-line react/prop-types
  const BannedReasonFilter = ({ column }) => {
    const options = Object.keys(BANNED_REASON).map((key) => (
      {
        label : BANNED_REASON[key],
        value : BANNED_REASON[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  const IsBannedCell     = (row) => ( row.cell.value ? 'Yes' : 'No' )
  const BannedReasonCell = (row) => StringUtil.humanize(row.cell.value)


  GenderFilter.propTypes     = filterPropTypes
  SellerTypeFilter.propTypes = filterPropTypes
  ActionCell.propTypes       = actionCellPropTypes

  return (
    [
      {
        Header   : 'Code',
        accessor : 'code'
      },
      {
        Header   : 'Name',
        accessor : 'name'
      },
      {
        Header   : 'Gender',
        accessor : 'gender',
        Filter   : GenderFilter,
        Cell     : GenderCell
      },
      {
        Header   : 'Username',
        accessor : 'username'
      },
      {
        Header   : <>Seller <br/> Type</>,
        accessor : 'seller_type',
        id       : 'seller_type',
        Filter   : SellerTypeFilter,
        Cell     : SellerTypeCell
      },
      {
        Header   : 'Mobile',
        accessor : 'mobile'
      },
      {
        Header   : 'Email',
        accessor : 'email'
      },
      {
        Header   : 'Is Banned',
        accessor : 'is_banned',
        Cell     : IsBannedCell,
        Filter   : IsBannedFilter
      },
      {
        Header   : 'Banned Reason',
        accessor : 'is_banned_reason',
        Cell     : BannedReasonCell,
        Filter   : BannedReasonFilter
      },
      {
        Header : 'Action',
        id     : 'action',
        Cell   : ActionCell
      }
    ]
  )
}

sellerTableColumns.propTypes = propTypes

export default sellerTableColumns
